import getters from './getters'
import mutations from './mutations'
import actions from './actions'

/** Only the session expiration survives a reload (the router guard reads
 * it); the user, their permissions and the settings are fetched again by
 * MainLayout (auth/refreshAuth), as in FM. */
function storedExpiration() {
  try {
    return (
      localStorage.getItem('sessionExpiration') ??
      // Sessions opened before the switch, kept by vuex-persistedstate.
      JSON.parse(localStorage.getItem('vuex') ?? 'null')?.auth
        ?.sessionExpiration ??
      null
    )
  } catch {
    return null
  }
}

export default {
  namespaced: true,
  state() {
    return {
      sessionExpiration: storedExpiration(),
      auth: {},
      errors: []
    }
  },
  getters,
  actions,
  mutations
}
